export const getOrderPlaybackConfig = (
  config?: Record<string, number>,
): OrderPlaybackConfig => {
  return {
    locationFadeIn: config?.locationFadeIn ?? 1000,
    timeFadeIn: config?.timeFadeIn ?? 2000,
    orderDetailsFadeIn: config?.orderDetailsFadeIn ?? 3000,
    lineItemsFadeIn: config?.lineItemsFadeIn ?? 4000,
    confirmationFadeIn: config?.confirmationFadeIn ?? 8000,
  };
};

type OrderPlaybackConfig = {
  locationFadeIn: number;
  timeFadeIn: number;
  orderDetailsFadeIn: number;
  lineItemsFadeIn: number;
  confirmationFadeIn: number;
};
